import { CoordinateType } from '../common/enums'
import { convertToFloat32 } from '../common/utils'

export interface DeviceConfig1Message {
  flagBatteryReadingEnabledInSnts: boolean
  flagTemperatureReadingEnabledInSchd: boolean
  sntsFrequency: number
  schdFrequency: number
  coordinateType: CoordinateType
  locationNSValue: number
  locationEWValue: number
}

export function decodeDeviceConfig1(data: Uint8Array): DeviceConfig1Message {
  const flagBatteryReadingEnabledInSnts = !!(data[0] & 0x80)
  const flagTemperatureReadingEnabledInSchd = !!(data[0] & 0x40)

  const sntsFrequency = data[0] & 0x1f
  const schdFrequency = data[1]
  const coordinateType =
    {
      0: CoordinateType.NotSet,
      1: CoordinateType.LatLong,
      2: CoordinateType.UTM,
      3: CoordinateType.MGRS,
    }[data[2]] || CoordinateType.NotSet
  const locationNSValue = convertToFloat32(data.slice(3))
  const locationEWValue = convertToFloat32(data.slice(7))

  return {
    flagBatteryReadingEnabledInSnts,
    flagTemperatureReadingEnabledInSchd,
    sntsFrequency,
    schdFrequency,
    coordinateType,
    locationNSValue,
    locationEWValue,
  }
}
